(() => {
  const roots = document.querySelectorAll('[data-sticky-card-stack]');

  if (!roots.length) return;

  const initializeRoot = (root) => {
    if (!root || root.dataset.stackInitialized === 'true') return;

    root.dataset.stackInitialized = 'true';

    const cards = Array.from(root.querySelectorAll('[data-stack-card]'));

    if (!cards.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = null;

    const updateCards = () => {
      frame = null;

      if (reducedMotion.matches) {
        cards.forEach((card) => {
          card.style.setProperty('--scs-current-scale', '1');
        });
        return;
      }

      const viewportHeight = window.innerHeight;

      cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const targetScale = parseFloat(getComputedStyle(card).getPropertyValue('--scs-target-scale')) || 1;
        const nextCard = cards[index + 1];

        if (!nextCard) {
          card.style.setProperty('--scs-current-scale', '1');
          return;
        }

        const nextRect = nextCard.getBoundingClientRect();
        const stickyTop = parseFloat(getComputedStyle(nextCard).top) || 0;
        const distance = Math.max(1, rect.height);
        const progress = Math.max(0, Math.min(1, (viewportHeight - nextRect.top - stickyTop) / distance));
        const scale = 1 - (1 - targetScale) * progress;

        card.style.setProperty('--scs-current-scale', scale.toFixed(4));
      });
    };

    const requestUpdate = () => {
      if (frame === null) {
        frame = window.requestAnimationFrame(updateCards);
      }
    };

    const cleanup = () => {
      window.removeEventListener('scroll', requestUpdate, { passive: true });
      window.removeEventListener('resize', requestUpdate, { passive: true });
      reducedMotion.removeEventListener?.('change', requestUpdate);

      if (frame !== null) {
        window.cancelAnimationFrame(frame);
      }

      delete root.dataset.stackInitialized;
    };

    const handleSectionUnload = (event) => {
      if (event.target === root || event.target.contains(root)) {
        cleanup();
        document.removeEventListener('shopify:section:unload', handleSectionUnload);
      }
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    reducedMotion.addEventListener?.('change', requestUpdate);
    document.addEventListener('shopify:section:unload', handleSectionUnload);

    updateCards();
  };

  roots.forEach(initializeRoot);
})();
